import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import HTML5Backend from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import { PUBLIC_URL } from './env'

// import * as serviceWorker from './serviceWorker'

console.log('NEW VERSION !!')

ReactDOM.render(<DndProvider backend={HTML5Backend}><App /></DndProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    //navigator.serviceWorker.register(PUBLIC_URL + '/sw.js');
    navigator.serviceWorker.getRegistrations().then( registrations => { 
      for(let registration of registrations) { registration.unregister() } 
    }); 
  });
}